if (!customElements.get('text-truncate')) {
  customElements.define('text-truncate', class extends HTMLElement {
    constructor() {
      super();
      this.target = this.parentElement;
      this.attachShadow({ mode: 'open' });
      if (this.shadowRoot) {
        this.shadowRoot.innerHTML = `
          <style>
            button {
              background: none;
              border: 0;
              border-bottom: 1px solid currentColor;
              color: var(--color-text, currentColor);
              cursor: pointer;
              font-size: inherit;
              padding: 0;
            }
          </style>
          <button type="button">Read More +</button>
        `;
        this.button = this.shadowRoot.querySelector('button');
        this.button.addEventListener('click', () => {
          this.button.textContent = this.target.classList.contains('text-block--expanded') ? 'Read More' : 'Read Less';
          this.target.classList.toggle('text-block--expanded');
        });
      }
    }
  });
}